const { REACT_APP_MAPBOX_ACCESS_TOKEN } = process.env;

const config = {
  style: 'mapbox://styles/mongabay/cmp16a81s000301s0c994ckvb',
  accessToken: REACT_APP_MAPBOX_ACCESS_TOKEN,
  theme: 'mongabay',

intro: {
title: "What does a map miss?",
subtitle: "A large-scale government-drafted map misses the details, driving a community anxious.",
date: 'May 19, 2026',
social: [
{ name: 'X', src: 'x.svg', href: 'https://x.com/mongabayindia' },
{ name: 'facebook', src: 'facebook.svg', href: 'https://www.facebook.com/mongabayindia/' },
],
},

logos: [
{ name: 'mongabay', src: 'mongabaylogo.png', width: '140', href: 'https://india.mongabay.com' },
],

alignment: 'left',
footer: 'Reporting and Images: Shreya Raman  |  Cartographer: Andrés Alegría  |  Producer: Kartik Chandramouli  |  Copy Edits: Priyanka Shankar',

  chapters: [

    // Chapter 1
    {
      id: "chapter-1",
      alignment: 'left',
      title: ' ',
      description: "This is a satellite view of a beach in Akkampettai, a village near Puducherry.",
      images: [
        { src: 'LocationMap.png', position: 'bottom', title: '', alt: 'Puducherry in an inset map to show where it is in India' },
      ],
      location: { center: [79.85320, 10.9697], zoom: 14.80, pitch: 50, bearing: -28 },
      onChapterEnter: [
        { layer: 'cover',                   opacity: 0 },
        { layer: 'icon_Turtle',             opacity: 1 },
        { layer: 'icon_Boat',               opacity: 1 },
        { layer: 'icon_Shelter',            opacity: 0 },
        { layer: 'icon_Dune',               opacity: 0 },
        { layer: 'icon_DryFish',            opacity: 1 },
        { layer: 'icon_Hall',               opacity: 0 },
        { layer: 'icon_Ice',                opacity: 0 },
        { layer: 'Akkampetai-overlay-14000',  opacity: 0 },
        { layer: 'Akkampetai-overlay-125000', opacity: 0 },
        { layer: 'Akkampetai',              opacity: 0 },
      ],
      onChapterExit: [],
    },

    // Chapter 2 — boats; slight pan south so the nesting site pan in ch3 reads as movement
    {
      id: "chapter-2",
      alignment: 'right',
      title: ' ',
      description: "Fisherfolk park their boats here. Every morning, they head out to sea. Every evening, they return to the same stretch of sand.",
      images: [
        { src: 'image1.JPG', position: 'top', title: '', alt: 'Fishing boats parked on the beach at Akkampetai' },
      ],
      location: { center: [79.85320, 10.9697], zoom: 18.15, pitch: 0, bearing: -28 },
      onChapterEnter: [
        { layer: 'icon_Boat', opacity: 1 },
      ],
      onChapterExit: [],
    },

    // Chapter 3 — turtle nesting; pan ~200 m north of ch2 centre
    {
      id: "chapter-3",
      alignment: 'right',
      title: ' ',
      description: "Just 200 metres away is a turtle nesting site. Elders in the village say turtles have come here for generations.",
      images: [
        { src: 'image2.JPG', position: 'top', title: '', alt: 'Marine turtle nesting site on the beach at Akkampetai' },
      ],
      location: { center: [79.85360, 10.97190], zoom: 18.15, pitch: 0, bearing: -28 },
      onChapterEnter: [
        { layer: 'icon_Turtle', opacity: 1 },
        { layer: 'icon_DryFish', opacity: 0 },

      ],
      onChapterExit: [],
    },

    // Chapter 4a
    {
      id: "chapter-4a",
      alignment: 'right',
      title: ' ',
      description: "Across the beach, blue tarpaulins stand out from above.",
      images: [
        { src: 'image3.JPG', position: 'top', title: '', alt: 'Fish-drying centre covered in blue tarpaulins near Akkampetai beach' },
      ],
      location: { center: [79.8516, 10.958], zoom: 17.250, pitch: 50, bearing: -28 },
      onChapterEnter: [
        { layer: 'icon_Turtle',              opacity: 0 },
        { layer: 'icon_Boat',               opacity: 0 },
        { layer: 'icon_Shelter',            opacity: 0 },
        { layer: 'icon_Dune',               opacity: 0 },
        { layer: 'icon_DryFish',            opacity: 1 },
        { layer: 'icon_Hall',               opacity: 0 },
        { layer: 'icon_Ice',                opacity: 0 },
        { layer: 'Akkampetai-overlay-14000',  opacity: 0 },
        { layer: 'Akkampetai-overlay-125000', opacity: 0 },
        { layer: 'Akkampetai',              opacity: 0 },
      ],
      onChapterExit: [
        { layer: 'icon_DryFish', opacity: 1 },
      ],
    },


    // Chapter 4b
    {
      id: "chapter-4b",
      alignment: 'right',
      title: ' ',
      description: "This is a roughly 300 square metres fish-drying centre. For several fisherwomen, it supports daily income.",
      images: [
        { src: 'image6.JPG', position: 'top', title: '', alt: 'Fisherwomen' },
      ],
      location: { center: [79.8516, 10.958], zoom: 17.250, pitch: 50, bearing: -28 },
      onChapterEnter: [
        { layer: 'icon_Turtle',             opacity: 1 },
        { layer: 'icon_Boat',               opacity: 1 },
        { layer: 'icon_Shelter',            opacity: 0 },
        { layer: 'icon_Dune',               opacity: 0 },
        { layer: 'icon_DryFish',            opacity: 1 },
        { layer: 'icon_Hall',               opacity: 0 },
        { layer: 'icon_Ice',                opacity: 0 },
        { layer: 'Akkampetai-overlay-14000',  opacity: 0 },
        { layer: 'Akkampetai-overlay-125000', opacity: 0 },
        { layer: 'Akkampetai',              opacity: 0 },
      ],
      onChapterExit: [
        { layer: 'icon_DryFish', opacity: 1 },
      ],
    },


    // Chapter 5
    {
      id: "chapter-5",
      type: "stage",
      stage: "PlainText",
      title: "",
      html: `<p style="text-align:center;">From space, these places look small. <br> <br> On the ground, they support livelihoods and biodiversity.</p>`,
      location: { center: [79.8516, 10.959621], zoom: 13.5, pitch: 0, bearing: 0 },
    },

    // Chapter 6
    {
      id: "chapter-6",
      alignment: 'left',
      title: ' ',
      description: "So, what happens when a map meant to guide infrastructure development and coastal protection misses these spots?",
      location: { center: [79.8516, 10.959621], zoom: 13.5, pitch: 0, bearing: 0 },
      onChapterEnter: [
        { layer: 'Akkampetai',              opacity: 0 },
        { layer: 'Akkampetai_2023',         opacity: 0 },
        { layer: 'icon_Turtle',             opacity: 1 },
        { layer: 'icon_Boat',               opacity: 1 },
        { layer: 'icon_DryFish',            opacity: 1 },        
      ],
      onChapterExit: [],
    },

// Chapter 7a
    {
      id: "chapter-7a",
      alignment: 'left',
      title: ' ',
      description: "The 2023 draft Coastal Zone Management Plan (CZMP) map for Karaikal district in Puducherry left out the fish-drying centre, the turtle nesting site, the boat parking area, and several everyday spaces used by fishing communities.",

      location: { center: [79.851655, 10.965644], zoom: 14.8, pitch: 0, bearing: 0 },
      onChapterEnter: [
       { layer: 'icon_Turtle',              opacity: 0 },
        { layer: 'icon_Boat',               opacity: 0 },
        { layer: 'icon_DryFish',            opacity: 0 },        
        { layer: 'Akkampetai_2023',         opacity: 1 },
        { layer: 'icon_Hall',               opacity: 0 },
        { layer: 'icon_Ice',                opacity: 0 },
      ],
      onChapterExit: [
      ],
    },


    // Chapter 7
    {
      id: "chapter-7",
      alignment: 'left',
      title: ' ',
      description: "A new version was prepared in September 2024, after communities objected to the earlier map that did not even identify or name fishing villages and marked entire stretches as tourism areas.",
      images: [
        { src: 'MAP_Legend_short.JPG', position: 'top', title: '', alt: 'Legend from the draft Coastal Zone Management Plan map for Karaikal district' },
      ],
      location: { center: [79.851655, 10.965644], zoom: 14.8, pitch: 0, bearing: 0 },
      onChapterEnter: [
        { layer: 'Akkampetai_2023',         opacity: 0 },
        { layer: 'Akkampetai',              opacity: 1 },
        { layer: 'icon_Hall',               opacity: 0 },
        { layer: 'icon_Ice',                opacity: 0 },
      ],
      onChapterExit: [
        { layer: 'Akkampetai_2023',         opacity: 0 },
      ],
    },
    
    

    // Chapter 8
    {
      id: "chapter-8",
      alignment: 'right',
      title: ' ',
      description: "The revised map includes some locations such as a community hall and an ice plant. <br> <br> But residents say many crucial spaces remain missing–",
      location: { center: [79.851655, 10.965644], zoom: 14.8, pitch: 0, bearing: 0 },
      onChapterEnter: [
       { layer: 'icon_Hall',    opacity: 1 },
        { layer: 'icon_Ice',     opacity: 1 },
        { layer: 'icon_Shelter', opacity: 0 },
        { layer: 'icon_Dune',    opacity: 0 },
        { layer: 'Akkampetai',   opacity: 1 },
      ],
      onChapterExit: [],
    },

    // Chapter 9
    {
      id: "chapter-9",
      alignment: 'right',
      title: ' ',
      description: "like a government-built fishermen's shelter",
      images: [
        { src: 'image4.JPG', position: 'top', title: '', alt: "Government-built fishermen's shelter..." },
      ],
      location: { center: [79.853368, 10.970092], zoom: 18.15, pitch: 0, bearing: 0 },
      onChapterEnter: [
        { layer: 'icon_Hall',    opacity: 1 },
        { layer: 'icon_Ice',     opacity: 1 },
        { layer: 'icon_Shelter', opacity: 1 },
        { layer: 'icon_Dune',    opacity: 0 },
        { layer: 'Akkampetai',   opacity: 0 },
      ],
      onChapterExit: [],
    },

    // Chapter 10
    {
      id: "chapter-10",
      alignment: 'right',
      title: ' ',
      description: "and sand dunes that protect inland areas from saltwater intrusion.",
      images: [
        { src: 'image5.JPG', position: 'top', title: '', alt: 'Sand dunes near the shoreline that protect against saltwater intrusion' },
      ],
      location: { center: [79.853614, 10.972842], zoom: 18.15, pitch: 0, bearing: 0 },
      onChapterEnter: [
        { layer: 'icon_Hall',               opacity: 1 },
        { layer: 'icon_Ice',                opacity: 1 },
        { layer: 'icon_Shelter',            opacity: 1 },
        { layer: 'icon_Dune',               opacity: 1 },
        { layer: 'Akkampetai',              opacity: 0 },
        { layer: 'Akkampetai-overlay-125000', opacity: 0 },
      ],
      onChapterExit: [
        { layer: 'icon_Hall',    opacity: 1 },
        { layer: 'icon_Ice',     opacity: 1 },
        { layer: 'icon_Shelter', opacity: 1 },
        { layer: 'icon_Dune',    opacity: 1 },
      ],
    },

    // Chapter 11 — "Scale." reveal; needs the breathing room from min-height on stage
    {
      id: "chapter-11",
      type: "stage",
      stage: "PlainText",
      title: "",
      html: `<p style="text-align:center;">Why are these places missing?</p>
<p style="text-align:center; font-size:54px; font-weight:bold; font-family:'Rowan', serif;">Scale.</p>`,
      location: { center: [79.851655, 10.965644], zoom: 14.8, pitch: 0, bearing: 0 },
      onChapterEnter: [
        { layer: 'Akkampetai-overlay-14000',  opacity: 0 },
        { layer: 'Akkampetai-overlay-125000', opacity: 0 },
      ],
      onChapterExit: [],
    },

    // Chapter 12
    {
      id: "chapter-12",
      alignment: 'left',
      title: ' ',
      description: "The draft map is drawn at 1:25,000. <br> <br> At this scale, one grid covers nearly 14 × 14 kilometres. <br> <br> A large-scale planning map​ can hide details and not give a full picture of how people use the landscape.",
      location: { center: [79.814736, 10.936032], zoom: 11, pitch: 0, bearing: 0 },
      onChapterEnter: [
        { layer: 'Akkampetai-overlay-14000',  opacity: 0 },
        { layer: 'Akkampetai-overlay-125000', opacity: 1 },
        { layer: 'Akkampetai',              opacity: 0 },
      ],
      onChapterExit: [
        { layer: 'Akkampetai-overlay-125000', opacity: 0 },
      ],
    },


    // Chapter 13a
    {
      id: "chapter-13a",
      alignment: 'left',
      title: ' ',
      description: "For reference, here’s a community-prepared, finer-scale 1:4,000 map that highlights the fish-drying site missed by the official maps.",
      location: { center: [79.852569, 10.967536], zoom: 14.7, pitch: 0, bearing: 0 },
      onChapterEnter: [
        { layer: 'Akkampetai-overlay-14000',  opacity: 1 },
        { layer: 'Akkampetai-overlay-125000', opacity: 0 },
      ],
      onChapterExit: [],
    },


    // Chapter 13b
    {
      id: "chapter-13b",
      alignment: 'left',
      title: ' ',
      description: "Authorities also prepare a map at 1:4,000 scale where one grid covers 2.7 × 2.7 kilometres. But this version does not go through public consultation.",
      location: { center: [79.852569, 10.967536], zoom: 14.0, pitch: 0, bearing: 0 },
      onChapterEnter: [],
      onChapterExit: [],
    },

    // Chapter 14
    {
      id: "chapter-14",
      type: "stage",
      stage: "PlainText",
      title: "",
      html: `<p style="text-align:center;">Fishing communities worry that not demarcating their commons on the map could lead to their spaces being opened up for tourism, real estate, or future infrastructure projects.</p>`,
    },

  ],
};

export default config;
